// extracted by mini-css-extract-plugin
module.exports = {"basic-table":"_4fGhU"};